import { render, staticRenderFns } from "./station.vue?vue&type=template&id=f019d232&"
import script from "./station.vue?vue&type=script&lang=js&"
export * from "./station.vue?vue&type=script&lang=js&"
import style0 from "./station.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports